import { render, staticRenderFns } from "./DespesaDetalhes.vue?vue&type=template&id=1dfe9511"
import script from "./DespesaDetalhes.vue?vue&type=script&lang=js"
export * from "./DespesaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports